// Bridges a UI interaction to both sinks: the engagement buffer (→ Worker →
// home box) and the local interest vector (→ client re-ranking). BUILD_PLAN.md
// §5.5: "Update the user's interest vector locally on every event."

import { engagement, type EngagementType } from "./engagement";
import { applyUpdate, loadInterestVector, saveInterestVector } from "./interest";
import type { ManifestEntry } from "./types";

/** How much each event type nudges the weight of the article's tags. An
 * impression is neutral (it's logged but shouldn't bias interests); explicit
 * positive signals raise weights; `hide` lowers them. */
export const INTEREST_DELTA: Record<EngagementType, number> = {
  impression: 0.0,
  click: 0.2,
  dwell_30s: 0.3,
  dwell_120s: 0.5,
  like: 1.0,
  hide: -1.0,
  share: 0.8,
};

/** Record an engagement event and fold it into the local interest vector. */
export async function trackEngagement(
  type: EngagementType,
  entry: ManifestEntry,
): Promise<void> {
  engagement.record(type, entry.id);
  const delta = INTEREST_DELTA[type];
  if (delta !== 0 && entry.tags && entry.tags.length > 0) {
    const vec = (await loadInterestVector()) ?? {};
    await saveInterestVector(applyUpdate(vec, entry.tags, delta));
  }
}
